module.exports = __webpack_public_path__ + "assets/img/starter_app_scss.3a13f5c1.jpg";